<template>
  <section class="introduction-section">
    <div class="introduction-section__body container">
      <h1 class="introduction-section__body__heading">
        Gateway to Africa
      </h1>
      <share class="text-left"></share>
    </div>
  </section>
</template>

<script>
import Share from '@/components/Share.vue'
import EmbedForm from '@/components/EmbedForm.vue'
import SmoothScroll from 'smooth-scroll'

export default {
  name: 'IntroductionSection',
  components: {
    Share,
    EmbedForm
  },
  methods: {
    goToMapSection () {
      // Scroll to the current step
      this.animateScroll(this.mapSectionElement)
    }
  },
  computed: {
    animateScroll () {
      // Create a scrolling context
      const scroll = new SmoothScroll(null, { offset: 0 })
      // Return the animateScroll function
      return scroll.animateScroll
    },
    mapSectionElement () {
      return document.getElementsByClassName('map-section')[0]
    }
  }
}
</script>

<style lang="scss">
  .introduction-section {
    background: theme-color('cuttysark') url("~images/bg.png") top right no-repeat;
    background-size: auto 100%;
    color:white;
    position: relative;

    @include media-breakpoint-down(md) {
      &:after {
        content:"";
        z-index: 50;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(theme-color('cuttysark'), 0.5);
      }
    }

    &__body {
      position: relative;
      z-index: 100;
      padding:5vh 0 5vh;

      @include media-breakpoint-down(lg) {
        padding: 2vh 5vh;
        padding-left: 7vh;
      }

      &__heading {
        font-size: 4rem;

        @include media-breakpoint-down(md) {
          font-size: 2rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// IntroductionSection.vue?2edb83c8